import script from "./FaqSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqSection.vue?vue&type=script&setup=true&lang=js"

import "./FaqSection.vue?vue&type=style&index=0&id=43878c40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43878c40"]])

export default __exports__